/*
  * 12     this.schema.properties.actions.items.anyOf[0].properties.action.enum = Object.keys(this.actions).sort();
  * 13     this.schema.properties.actions.items.anyOf[0].allOf = Object.values(this.actions).sort();
**/
export const base_schema = {
    "$schema": "http://json-schema.org/draft-07/schema#",
    "$ref": "#/definitions/Container",
    "definitions": {
    	"Container": {
        	"type": "object",
            "required": [
              "command",
              "description",
              "actions"
             ],
             "additionalProperties": false,
             "properties": {
               "command": { "$ref": "#/definitions/CommandName" },
               "params": { "$ref": "#/definitions/Parameters" },
               "description": { "$ref": "#/definitions/Description" },
               "actions": { "$ref": "#/definitions/Actions" }
             }
        },
        "CommandName": {
			"type": "string",
			"pattern": "^[a-z][a-z0-9-_]+$",
			"message": {
				"required": "Command Name is required",
				"pattern": "Command Name accepts lower case alphanumeric input, dashes, and hyphens. Don't use spaces, and must start with a letter."
			}
        },
        "Parameters": {
			"type": "array",
			"additionalItems": false,
			"items": {
				"type": "object",
				"required": [
					"name",
					"type",
					"position"
				],
				"additionalProperties": false,
				"properties": {
					"name": {
						"type": "string"
					},
					"type": {
						"enum": [
							"active",
							"boss",
							"card",
							"character",
							"collectible",
							"costume",
							"curse",
							"enemy",
							"friend",
							"givable",
							"monster",
							"number",
							"passive",
							"pill",
							"room",
							"spawnable",
							"stat",
							"string",
							"takable",
							"trinket",
							"poopspell"
						]
					},
					"position": {
						"enum": [
							"next",
							"rest"
						]
					}
				}
                        }
        },
        "Description": {
			"type": "string",
			"pattern": "^[ -×ff]+$"
        },
		"Actions": {
			"type": "array",
			"additionalItems": false,
			"items": {
				"anyOf": [{
					"type": "object",
					"required": [
						"action"
					],
					"additionalProperties": false,
					"properties": {
						"action": {
							"enum": [/* list of action names */]
						},
						"params": {
							"type": "object"
						}
					},
					"allOf": [ /*list of action definitions */ ]
				}]
			}
		}
	}
}

